import Image from 'next/image';
import MarkdownCopy from '@components/cms/Slices/MarkdownCopy';
import Container from '@components/global/Container';
import Button from '@components/ui/Button';
import Heading from '@components/ui/Heading';
import { HeroSlice } from '@adapters/prismic/types/brandedStorePage';

import styles from './HeroTextBlock.module.scss';

const HeroTextBlock = ({
  primary,
  locale,
  handleClick,
}: HeroSlice & { handleClick?: () => void }) => {
  const handleButtonClick = () => {
    if (handleClick) {
      handleClick();
    }
    if (!primary?.cta_link) {
      const plpContainer = document.getElementById('plpContainer');
      if (plpContainer) {
        plpContainer.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  return (
    <Container className={styles.heroTextBlockContainer}>
      {primary?.logo?.url && (
        <div className={styles.logoContainer}>
          <Image
            src={primary?.logo.url}
            alt={primary?.logo?.alt || ''}
            fill
            sizes="100vw"
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      )}
      {primary.title && (
        <Heading
          semanticLevel="h1"
          styleLevel="1"
          className={styles.heroHeading}
        >
          {primary?.title}
        </Heading>
      )}
      {primary?.copy && (
        <MarkdownCopy
          text={primary?.copy?.[0]?.text ?? ''}
          className={styles.copy}
        />
      )}
      {primary?.cta_label && (
        <Button
          className={styles.cta}
          label={primary.cta_label}
          size="large"
          variant={primary.cta_importance}
          type="button"
          handleClick={handleButtonClick}
          href={
            primary?.cta_link ? `/${locale}${primary?.cta_link}` : undefined
          }
        />
      )}
    </Container>
  );
};

export default HeroTextBlock;
